import _startsWith from "lodash/startsWith";
import _isString from "lodash/isString";
import "core-js/modules/es6.regexp.replace.js";
import appConfig from '@nerdwallet/app-config';
/**
 * Determine whether a link is external, meaning it
 * points to a non-NerdWallet domain.
 *
 * @param url - URL
 * @returns - Whether or not the link is external.
 */

var isExternalLink = function isExternalLink(url) {
  if (!url || !_isString(url)) return false;
  var siteBaseUrl = appConfig.SITE_BASE_URL;
  return !_startsWith(url, siteBaseUrl) && !_startsWith(url, siteBaseUrl.replace('https://', 'http://')) && !_startsWith(url.replace('//', 'https://'), siteBaseUrl) && !/^\.{0,2}\/[^/]/.test(url);
};

export default isExternalLink;